module.exports = __webpack_public_path__ + "img/aboutUsChina.7c57280e.gif";